<template>
  <div :style="{
    color:option.attribute.textColor,
    fontSize: option.attribute.fontSize+'px',
    textAlign:option.attribute.textAlign,
    fontWeight:option.attribute.fontWeight,
    fontFamily:option.attribute.fontFamily
  }"
       @click="clickHandler">{{datetime + weekday}}</div>
</template>

<script>
import {getDataJson, pollingRefresh} from "@/utils/refresh-cpt-data";

export default {
  name: "cpt-datetime",
  props:{option:Object,components: Array, current: Object},
  watch:{
    'option.attribute':{
      handler() {
        this.refreshCptData(this.option.cptDataForm);
      },
      deep: true
    },
    "current.cptShow"(val) {
      console.log('text-show-', val);
      if (val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
    "option.attribute.hideCompInTab"(val) {
      // 组合选项卡内显示时
      if (!val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    }
  },
  data(){
    return {
      timer:null,
      datetime:'',
      weekday:'',
      uuid:''
    }
  },
  computed: {
    dataReload() {
      return this.option.attribute.globalDataReload || [0]
    },
  },
  created() {
    this.uuid = require('uuid').v1();
    // 新增属性兼容旧代码
    if (!this.option.attribute.globalDataReload) {
      this.option.attribute.globalDataReload = [0]
    }
    //判断此控件在九宫格里面就不请求数据
    if(this.current.cptOption.interaction.fatherGridId && isFromGrid != 'ninegrid')return 
    if (this.dataReload.includes(0)) {
      this.refreshCptData();
    }
  },
  methods:{
    refreshCptData(cptDataForm = this.option.cptDataForm,paras){
      if(cptDataForm){
        pollingRefresh(this.uuid, cptDataForm, ()=>{this.loadData(cptDataForm,paras)},this.components)
      }else{
        this.loadData();
      }
    },
    loadData(cptDataForm,paras){
      const that = this;
      if(this.timer){
        clearInterval(this.timer);
      }
      if(that.option.attribute.dataType === 1){
        getDataJson(cptDataForm,paras,(res)=> {
          that.datetime = that.dateFormat(new Date(res.value), (that.option.attribute.showDate?that.option.attribute.format:'') + (that.option.attribute.showTime?' hh:mm:ss':''));
          that.calcWeekday(new Date(res.value))

        })
      }else{
        that.datetime = that.dateFormat(new Date(), (that.option.attribute.showDate?that.option.attribute.format:'') + (that.option.attribute.showTime?' hh:mm:ss':''));
        that.timer = setInterval(function () {
          that.datetime = that.dateFormat(new Date(), (that.option.attribute.showDate?that.option.attribute.format:'') + (that.option.attribute.showTime?' hh:mm:ss':''));
          that.calcWeekday(new Date())
        }, 1000)
      }
    },
    calcWeekday(date){
      const weekHanz = ['日','一','二','三','四','五','六'];
      if(this.option.attribute.showWeek){
        this.weekday = ' 星期'+weekHanz[date.getDay()]
      }else{
        this.weekday = ''
      }
    },
    dateFormat(date, formatter) {
      if (formatter === ''){
        return formatter;
      }
      let hours = date.getHours()
      if(this.option.attribute.hourType === 1){
        hours = hours>12?hours-12:hours;
      }
      const o = {
        "M+": date.getMonth() + 1,  // 月
        "d+": date.getDate(),       // 日
        "h+": hours,      // 时
        "m+": date.getMinutes(),    // 时
        "s+": date.getSeconds(),    // 秒
        "q+": Math.floor((date.getMonth() + 3) / 3),      // 季度
        "S": date.getMilliseconds() // 毫秒
      };
      if (/(y+)/.test(formatter)) {
        formatter = formatter.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      }
      for (let k in o) {
        if (new RegExp("(" + k + ")").test(formatter)) formatter = formatter.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
      }
      return formatter;
    },
    clickHandler(){
      this.$emit("clickHandler",this.option.interaction,'default',this.datetime,'cpt-datetime')
    }
  },
  beforeUnmount() {
    clearInterval(this.timer);
  }
}
</script>

<style scoped>

</style>
